import React, { useEffect, useState } from 'react';
import { fetchDCNPrice, fetchDcnToken } from '../../utils';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { api as axios } from '../../api';
import * as actionTypes from '../../store/actionTypes';
import TokenTable from '../../components/Tables/TokenTable/token.table';
import EthWallet from '../../components/nav/web3wallet';
import CommonMenu from '../../components/commonMenu/commonMenu';
import MarketStats from '../../components/MarketStats/MarketStats';
import { useTokenListing, ListingFooter } from '../../hooks/useTokenListing';
const DcnTokensTable = () => {
  const dispatch = useDispatch();
  const loading = false;
  const { PecuPrice, synthetics, dcnTokens, dcnPrice, UserInfo, isAdmin } =
    useSelector(
      (state) => ({
        PecuPrice: state.PecuPrice,
        synthetics: state.synthetics,
        dcnTokens: state.dcnTokens,
        dcnPrice: state.dcnPrice,
        UserInfo: state.UserInfo,
        isAdmin: state.isAdmin
      }),
      shallowEqual
    );

  const [open, setOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState({});
  const [tvl, setTvl] = useState();
  const [priceList, setPriceList] = useState([]);
  const [blinkUpList, setBlinkUpList] = useState([]);
  const [blinkDownList, setBlinkDownList] = useState([]);
  const [trendHourly, setTrendHourly] = useState({});
  const [coinVolume, setCoinVolume] = useState(114826.00453596);
  const [trend, setTrend] = useState({});
  const [priceDown, setPriceDown] = useState(false);
  const [searchToken, setSearchToken] = useState('');
  const filterToken = (searchToken) => {
    if (searchToken && searchToken !== '') {
      return dcnTokens?.filter(
        (e) =>
          e.symbol.toLowerCase().includes(searchToken.toLowerCase()) ||
          e.name.toLowerCase().includes(searchToken.toLowerCase())
      );
    } else {
      return dcnTokens;
    }
  };

  const get_change_index_coin_hourly = () => {
    axios.get(`/wallet/get_change_index_coin_hourly`).then((res) => {
      setTrendHourly(res.data);
    });
  };
  const calculate_daily_volume = () => {
    axios.get(`/wallet/calculate_daily_volume`).then((res) => {
      setCoinVolume(res.data.total_volume);
    });
  };
  const get_tvl = () => {
    axios.get(`/wallet/tvl`).then((res) => {
      setTvl(res.data.tvl);
    });
  };
  const get_change_index_coin = () => {
    axios.get(`/wallet/get_change_index_coin`).then((res) => {
      setTrend(res.data);
    });
  };
  function getFormattedTime(timestampString) {
    const timestamp = new Date(timestampString);
    timestamp.setHours(timestamp.getHours());
    return timestamp;
  }

  useEffect(() => {
    get_change_index_coin_hourly();
    get_change_index_coin();
    calculate_daily_volume();
    get_tvl();
  }, []);

  useEffect(() => {
    fetchDcnToken(dispatch, actionTypes.FETCH_DCN_TOKEN_COIN);
    fetchDCNPrice(dispatch, actionTypes.FETCH_DCN_PRICE);
  }, []);

  // Search + pagination over the WHOLE list (see hooks/useTokenListing).
  const listing = useTokenListing(dcnTokens, searchToken);

  return (
    <div
      className="screen"
      style={{
        zIndex: '100',
        position: 'sticky',
        width: '100%',
        marginBottom: '1rem'
      }}
    >

      <div
        style={{
          width: '95%',
          minWidth: '340px'
        }}
        className="res-token"
      >

        <MarketStats />
        <CommonMenu label={'DCN Tokens'} setSearch={setSearchToken} />
        <TokenTable
          loading={loading}
          token={listing.pageRows}
          blinkUpList={blinkUpList}
          blinkDownList={blinkDownList}
          href={'dcn'}
          PecuPrice={PecuPrice}
          swappable={true}
          getFormattedTime={getFormattedTime}
          showPecu={false}
          priceData={dcnPrice}
        />
        <ListingFooter
          listing={listing}
          loaded={dcnTokens?.length > 0}
          noun="DCN tokens"
        />
      </div>
    </div>
  );
};

export default React.memo(DcnTokensTable);
